module.exports = __webpack_public_path__ + "static/media/7. Abandono, Óxido sobre lámina de hierro, 122 x 122 cm, 2019 copy.46b09959.png";